<template>
  <div class="mod-tools">
    <div
      v-if="canApprove"
      class="mod-tools__button mod-tools__button--highlight"
      @click="approveMessage"
    ></div>
    <div
      v-if="canUndo"
      class="mod-tools__button mod-tools__button--undo"
      @click="undoMessage"
    ></div>
  </div>
</template>

<script>
import { mapState } from "vuex"

export default {
  props: {
    message: Object,
    canApprove: Boolean,
    canUndo: Boolean
  },
  methods: {
    approveMessage() {
      const { type, userId, author, colorCode, messageId, data } = this.message

      this.$store.dispatch("chatStore/approveMessage", [
        type == "text" && data.text.length > 0 ? data.text : data.emoji,
        userId,
        author,
        colorCode,
        messageId
      ])
    },
    undoMessage() {
      const { type, userId, author, colorCode, messageId, data } = this.message

      this.$store.dispatch("chatStore/undoMessage", [
        type == "text" && data.text.length > 0 ? data.text : data.emoji,
        userId,
        author,
        colorCode,
        messageId
      ])
    }
  },
  computed: mapState({
    userId({ identityStore }) {
      return identityStore.localStorageId
    },
    user({ identityStore }) {
      return identityStore.name
    }
  })
}
</script>

<style lang="scss">
.mod-tools {
  position: absolute;
  top: 100%;
  left: 100%;
  width: 90px;
  height: 40px;
  z-index: 100;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  &__button {
    flex: 0 0 40px;
    width: 40px;
    height: 40px;
    border-radius: 999px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transform: scale(0.5);
    opacity: 0;
    transition: transform 0.2s ease 0.1s, opacity 0.1s linear,
      background-color 0.2s linear;
    background-size: 60%;
    background-position: center;
    background-repeat: no-repeat;

    &--undo {
      background-color: rgba(200, 50, 50, 0.75);
      background-image: url("/assets/icons/bin.png");

      &:hover {
        background-color: rgba(200, 50, 50, 1);
      }
    }

    &--highlight {
      background-color: rgba(0, 230, 50, 0.75);
      background-image: url("/assets/icons/star.png");

      &:hover {
        background-color: rgba(0, 230, 50, 1);
      }
    }

    .sc-message:hover & {
      transition: transform 0.2s ease, opacity 0.1s linear;
      transform: scale(1);
      opacity: 1;
    }
  }
}
</style>
